// extracted by mini-css-extract-plugin
export default {"goals":"Goals_goals__57flh","header":"Goals_header__qLapx","row":"Goals_row__ABWzc","select":"Goals_select__vLpfS"};